import { createSvgIcon } from '@mui/material';
import React from 'react';

export const Details = createSvgIcon(
    <>
        <path
            d="M7.45 17.45L6.05 16.05L9.075 13H2V11H9.075L6.05 7.95005L7.45 6.55005L12.9 12L7.45 17.45ZM13 17V15H22V17H13ZM13 9.00005V7.00005H22V9.00005H13ZM16 13V11H22V13H16Z"
            fill="currentColor"
        />
    </>,
    'Details'
);
